import { render, staticRenderFns } from "./PositionAdjust.vue?vue&type=template&id=0603d276&"
import script from "./PositionAdjust.vue?vue&type=script&lang=ts&"
export * from "./PositionAdjust.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports